
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M249.927 363.79c-5.39-42.045-31.226-77.086-66.591-95.762-14.944 14.963-35.577 24.226-58.335 24.226-22.754 0-43.391-9.263-58.338-24.226C31.298 286.704 5.459 321.745.072 363.79c-.318 2.473.428 4.886 2.09 6.775 1.922 2.188 4.786 3.44 7.858 3.44h229.961c3.068 0 5.935-1.251 7.86-3.44 1.669-1.9 2.406-4.302 2.086-6.775zM73.184 258.938a74.563 74.563 0 004.192 4.05c12.672 11.345 29.333 18.302 47.625 18.302s34.953-6.968 47.625-18.302a75.25 75.25 0 004.192-4.05 76.324 76.324 0 003.865-4.362c9.924-12.303 15.907-27.926 15.907-44.935 0-39.509-32.119-71.646-71.59-71.646-39.472 0-71.59 32.143-71.59 71.646 0 17.009 5.98 32.632 15.907 44.935 1.223 1.511 2.524 2.948 3.867 4.362zM511.927 363.79c-5.39-42.045-31.226-77.086-66.591-95.762-14.944 14.963-35.577 24.226-58.335 24.226-22.755 0-43.391-9.263-58.339-24.226-35.364 18.676-61.203 53.717-66.591 95.762-.317 2.473.428 4.886 2.091 6.775 1.922 2.188 4.786 3.44 7.857 3.44h229.962c3.068 0 5.935-1.251 7.86-3.44 1.669-1.9 2.406-4.302 2.086-6.775zM335.184 258.938a74.224 74.224 0 004.192 4.05c12.672 11.345 29.333 18.302 47.625 18.302s34.953-6.968 47.625-18.302a75.25 75.25 0 004.192-4.05 76.324 76.324 0 003.865-4.362c9.924-12.303 15.907-27.926 15.907-44.935 0-39.51-32.119-71.646-71.59-71.646-39.472 0-71.591 32.143-71.591 71.646 0 17.009 5.98 32.632 15.907 44.935 1.223 1.512 2.525 2.948 3.868 4.362z"}})])
          )
        }
      }
    